<div class="p-inputgroup">
    <p-chips
        id="organizationChips"
        [(ngModel)]="peoplePicker"
        [ngModelOptions]="{ standalone: true }"
        [max]="8"
        [allowDuplicate]="false"
        [disabled]="disabled"
        (onRemove)="onRemove()"
        class="hvl-entity-picker-chips"
        styleClass="hvl-entity-picker-chips-override"
    >
        <ng-template let-item pTemplate="item">
            {{ item }}
        </ng-template>
    </p-chips>

    <button (click)="onShow()" [disabled]="disabled" id="organizationPickerButton" label=" " class="btn-icon-only hvl-entity-picker-search-button" pButton type="button">
        <i aria-hidden="true" class="material-icons">search</i>
    </button>
</div>
